import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6e449ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "menu-expand-controls",
  "aria-label": "功能菜单展开控制"
}
const _hoisted_2 = ["disabled", "aria-label", "title", "aria-expanded"]
const _hoisted_3 = {
  viewBox: "0 0 20 20",
  "aria-hidden": "true"
}
const _hoisted_4 = ["d"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "menuHost",
    class: "siderbar-menu",
    onPointerover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fitCollapsedPopup && _ctx.fitCollapsedPopup(...args))),
    onFocusin: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fitCollapsedPopup && _ctx.fitCollapsedPopup(...args)))
  }, [
    (_ctx.store.getters.sideBarOpened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            type: "button",
            disabled: !_ctx.menus.length,
            "aria-label": _ctx.allMenusExpanded?'全部收起':'全部展开',
            title: _ctx.allMenusExpanded?'全部收起':'全部展开',
            "aria-expanded": _ctx.allMenusExpanded,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAllMenus && _ctx.toggleAllMenus(...args)))
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_3, [
              _createElementVNode("path", {
                d: _ctx.allMenusExpanded?'m5 9 5-4 5 4M5 15l5-4 5 4':'m5 5 5 4 5-4M5 11l5 4 5-4'
              }, null, 8, _hoisted_4)
            ]))
          ], 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_menu, {
      mode: "inline",
      "inline-indent": 10,
      theme: "dark",
      "inline-collapsed": !_ctx.store.getters.sideBarOpened,
      openKeys: _ctx.openKeys,
      onOpenChange: _ctx.onOpenChange,
      selectedKeys: _ctx.selectedKeys,
      "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedKeys) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (menu.children && menu.children.length>0)
              ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                  key: menu.path,
                  "popup-class-name": "admin-sidebar-popup"
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_svg_icon, {
                      fit: "",
                      class: _normalizeClass(['ant-menu-item-icon',_ctx.store.getters.sideBarOpened?'menu-icon':'plus-menu-icon']),
                      icon: _ctx.menuIcon(menu)
                    }, null, 8, ["class", "icon"])
                  ]),
                  title: _withCtx(() => [
                    _createElementVNode("span", {
                      title: _ctx.generateTitle(menu.key || menu.title, menu.title)
                    }, _toDisplayString(_ctx.generateTitle(menu.key || menu.title, menu.title)), 9, _hoisted_5)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, (submenu, sindex) => {
                      return (_openBlock(), _createBlock(_component_a_menu_item, {
                        title: false,
                        "aria-keyshortcuts": submenu.path==='/orders/all'?'Alt+w':undefined,
                        onClick: ($event: any) => (_ctx.menuClick(submenu,'ss'+sindex)),
                        key: submenu.path
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.generateTitle(submenu.key || submenu.title, submenu.title)), 1),
                          (submenu.path==='/orders/online-nesting'&&_ctx.failedCount)
                            ? (_openBlock(), _createBlock(_component_a_badge, {
                                key: 0,
                                count: _ctx.failedCount,
                                style: {"margin-left":"8px"}
                              }, null, 8, ["count"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["aria-keyshortcuts", "onClick"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: menu.path,
                  onClick: ($event: any) => (_ctx.menuClick(menu,'k'+index))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_svg_icon, {
                      fit: "",
                      class: _normalizeClass(['ant-menu-item-icon',_ctx.store.getters.sideBarOpened?'menu-icon':'plus-menu-icon']),
                      icon: _ctx.menuIcon(menu)
                    }, null, 8, ["class", "icon"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      title: _ctx.generateTitle(menu.key || menu.title, menu.title)
                    }, _toDisplayString(_ctx.generateTitle(menu.key || menu.title, menu.title)), 9, _hoisted_6)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
          ], 64))
        }), 256))
      ]),
      _: 1
    }, 8, ["inline-collapsed", "openKeys", "onOpenChange", "selectedKeys"]),
    _createElementVNode("div", {
      class: "org-info",
      title: _ctx.userInfo.nickName
    }, _toDisplayString(_ctx.userInfo.nickName), 9, _hoisted_7)
  ], 544))
}